export default {"src":"/_next/static/media/charge.7a2c3a51.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};